import {
  Component,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  SiteAlertsService,
  SiteAlertLevel,
} from 'src/app/core/services/site-alerts.service';

@Component({
  selector: 'app-site-alert-banner',
  templateUrl: './site-alert-banner.component.html',
  styleUrls: ['./site-alert-banner.component.scss']
})
export class SiteAlertBannerComponent implements OnInit, OnDestroy {
  show = false;
  level: SiteAlertLevel = 'info';
  message = '';

  private destroy$ = new Subject<void>();

  private siteAlertsService = inject(SiteAlertsService);

  ngOnInit(): void {
    this.siteAlertsService
      .getLoginWarning()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          const trimmedMessage = response?.message?.trim() || '';
          if (!response?.enabled || !trimmedMessage) {
            this.show = false;
            return;
          }

          this.level = this.normalizeLevel(response.level);
          this.message = trimmedMessage;
          this.show = true;
        },
        error: () => {
          this.show = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private normalizeLevel(level: string | null | undefined): SiteAlertLevel {
    if (level === 'warning' || level === 'danger' || level === 'info') {
      return level;
    }
    return 'info';
  }
}
